<div class="body-cas" *ngIf="open">
  <cas-modal width="90vw" open="true">
    <div class="top-right-icon">
      <cas-icon name="flat-close" size="16" (click)="close()"></cas-icon>
    </div>
    <cas-text variant="headline1" class="pdf-preview-title">{{ title }}</cas-text>
    <div class="pdf-preview-frame">
      <iframe
        *ngIf="safeSrc"
        class="pdf-preview-iframe"
        [src]="safeSrc"
        [title]="title">
      </iframe>
    </div>
    <div class="bottom bottom-compact">
      <div class="separator"></div>
      <div class="pdf-preview-actions">
        <cas-button
          [text]="CONST_AUTOADM.MODAL_PDF_BTN_CERRAR"
          variant="text1"
          (click)="close()">
        </cas-button>
        <cas-button
          [text]="CONST_AUTOADM.MODAL_PDF_BTN_DESCARGAR"
          variant="primary1"
          iconName="flat-download"
          iconSize="16"
          (click)="download()">
        </cas-button>
      </div>
    </div>
  </cas-modal>
</div>
